import React, { useEffect } from 'react';
import Button from 'src/components/10-atoms/button/Button';
import Field from 'src/components/10-atoms/form/Field';
import { getFieldError } from 'src/components/10-atoms/form/hooks/useFieldState/utils';
import TextInput from 'src/components/10-atoms/form/inputs/TextInput';
import BottomDrawerLayout from 'src/components/20-helper-views/bottom-drawer/BottomDrawerLayout';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
import { snackbarHelperActions } from 'src/components/20-helper-views/snackbar/useSnackbar';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useI18n from 'src/modules/translations/hooks/useI18n';
import useData from './useData';
const SubjectFormDrawer = ({ examLevelID, type, subject, }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    const [state, actions] = useData(examLevelID, type, subject);
    const isLoading = state.createMutation.loading || state.updateMutation.loading;
    useEffect(() => {
        if (state.createMutation.data || state.updateMutation.data) {
            bottomDrawerHelperActions.hide();
            snackbarHelperActions.show({
                variant: 'POSITIVE',
                duration: 'SHORT',
                message: state.isEditMode
                    ? translate('Subject updated successfully')
                    : translate('Subject created successfully'),
            });
        }
    }, [state.createMutation.data, state.updateMutation.data]);
    return (React.createElement(BottomDrawerLayout, null,
        React.createElement(BottomDrawerLayout.Title, null, state.isEditMode
            ? translate('Edit Subject')
            : translate('Create Subject')),
        React.createElement(BottomDrawerLayout.ScrollableBody, null,
            React.createElement(Field, { label: translate('Title'), error: getFieldError(state.form.fields.title.errors) },
                React.createElement(TextInput, { autoFocus: true, placeholder: translate('Enter subject title'), value: state.form.fields.title.value, onChange: actions.form.fields.title.setValue, maxLength: 200, editable: !isLoading })),
            state.isEditMode && (React.createElement(Field, { label: translate('Description'), error: getFieldError(state.form.fields.description.errors) },
                React.createElement(TextInput, { placeholder: translate('Enter subject description'), value: state.form.fields.description.value, onChange: actions.form.fields.description.setValue, maxLength: 500, editable: !isLoading })))),
        React.createElement(BottomDrawerLayout.Actions, { btw: 1, spacing: theme.spacing.standard.md, pv: theme.spacing.standard.sm },
            React.createElement(Button, { loading: isLoading, flex: true, onPress: actions.handleSubmit }, state.isEditMode ? translate('Update') : translate('Create')))));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default SubjectFormDrawer;
